import { useStore } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { PlansFlagsResult } from '../types';

const usePlansFlags = (): PlansFlagsResult => {
  const { fePlansV2EnableModule, fePlansV2EnableModuleByOrg } = useFlags();

  const { state } = useStore();
  const { id } = state?.organization || {};

  const fePlansActive = featureFlagRenderItem(
    fePlansV2EnableModule,
    fePlansV2EnableModuleByOrg,
    id
  );

  return { fePlansActive };
};

export default usePlansFlags;
